import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CharonService } from '@quickweb/connect-angular';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { CaronteService } from './core/services/caronte/caronte.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private charonService: CharonService, private caronteService: CaronteService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = new URL(req.url);

    if (url.origin === environment.ciamAuth.issuer) {
      // @ts-ignore
      const caronteEndpoint = environment.caronte[url.pathname];
      const headers = {
        headers: new HttpHeaders({
          'x-itau-apikey': environment.apiKey
        })
      };

      if (caronteEndpoint) {
        const caronteReq = req.clone({
          ...headers,
          url: caronteEndpoint
        });

        this.caronteService.initialize(caronteEndpoint);
        return this.charonService.request(caronteReq);
      }
    }

    return next.handle(req);
  }
}
